<template>
  <div>
    <div class="text-h6 mb-4">По всем вопросам:</div>

    <v-btn :href="mailGeneralLink" text color="info">
      <v-icon class="mr-2">mdi-email</v-icon>
      Написать на электропочту
    </v-btn>
  </div>
</template>

<script>
export default {
  name: "SupportView",
  data() {
    return {
      mailGeneral: {
        address: 'rodinfm307@ya.ru',
        subject: 'Вопрос по сервису экспорта расписаний МАИ'
      }
    }
  },
  computed: {
    mailGeneralLink: function () {
      return 'mailto:' + this.mailGeneral.address + '?subject=' + this.mailGeneral.subject
    }
  }
}
</script>

<style scoped>

</style>